module.exports = __webpack_public_path__ + "img/744.e20ffc0a.jpg";